import { render, staticRenderFns } from "./table-element.vue?vue&type=template&id=7adb9731&scoped=true"
import script from "./table-element.vue?vue&type=script&lang=js"
export * from "./table-element.vue?vue&type=script&lang=js"
import style0 from "./table-element.vue?vue&type=style&index=0&id=7adb9731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adb9731",
  null
  
)

export default component.exports